import {
  FETCH_FILES_REQUEST,
  FETCH_FILES_SUCCESS,
  FETCH_FILES_FAILURE,
  FETCH_STARRED_FILES,
  FETCH_SHARED_FILES,
  FETCH_DELETED_FILES,
  UPDATE_HOME_FILES,
  UPDATE_STARRED_FILES,
  UPDATE_DELETED_FILES,
} from "./FileTypes";

export const fetchFilesRequest = () => {
  return {
    type: FETCH_FILES_REQUEST,
  };
};

export const fetchFilesSuccess = (files) => {
  return {
    type: FETCH_FILES_SUCCESS,
    payload: files,
  };
};

export const fetchFilesFailure = (error) => {
  return {
    type: FETCH_FILES_FAILURE,
    payload: error,
  };
};

export const fetchStarredFilesSuccess = (files) => {
  return {
    type: FETCH_STARRED_FILES,
    payload: files,
  };
};

export const fetchSharedFilesSuccess = (files) => {
  return {
    type: FETCH_SHARED_FILES,
    payload: files,
  };
};

export const fetchDeletedFilesSuccess = (files) => {
  return {
    type: FETCH_DELETED_FILES,
    payload: files,
  };
};

export const updateHomeFiles = (homeFiles) => {
  return {
    type: UPDATE_HOME_FILES,
    payload: homeFiles,
  };
};

export const updateStarredFiles = (starredFiles) => {
  return {
    type: UPDATE_STARRED_FILES,
    payload: starredFiles,
  };
};

export const updateDeletedFiles = (deletedFiles) => {
  return {
    type: UPDATE_DELETED_FILES,
    payload: deletedFiles,
  };
};
